import { TranslationMap } from '@trimble-gcs/i18n-types';

export function licenseCheckTranslations() {
  return {
    loading: {
      text: $localize`:@@license.loading:Loading license...`,
      desc: 'Message displayed while license is loading and validated.',
    },
    noLicense: {
      title: {
        text: $localize`:@@license.noLicense.title:No Active License Found`,
        desc: 'Title displayed when the project has no active application license.',
      },
      message: {
        text: $localize`:@@license.noLicense.message:There is currently no active license for this project.`,
        desc: 'Message displayed when the project has no active application license.',
      },
    },
    accountNotAllowed: {
      title: {
        text: $localize`:@@license.accountNotAllowed.title:Account Not Allowed`,
        desc: 'Title displayed when the project account type is not supported.',
      },
      message: {
        text: $localize`:@@license.accountNotAllowed.message:The project uses an account type that is not allowed.`,
        desc: 'Message displayed when the project account type is not supported.',
      },
    },
    regionNotAvailable: {
      title: {
        text: $localize`:@@license.regionNotAvailable.title:Region Not Supported Yet`,
        desc: 'Title displayed when the project region is not supported.',
      },
      message: {
        text: $localize`:@@license.regionNotAvailable.message:Connect is growing fast, but {Reality Capture} hasn't quite made it to this one. Check back soon! We're working hard to expand our map.`,
        desc: "Message displayed when the project region is not supported. The term 'Reality Capture' is the product name and is not translated.",
      },
    },
    unknownError: {
      title: {
        text: $localize`:@@license.unknownError.title:Error Loading License`,
        desc: 'Title displayed when there was an error loading the license.',
      },
      message: {
        text: $localize`:@@license.unknownError.message:There was an error loading your license.`,
        desc: 'Message displayed when there was an error loading the license.',
      },
      retry: {
        text: $localize`:@@license.unknownError.retry:Retry`,
        desc: 'Button text to retry loading the license.',
      },
    },
  } satisfies TranslationMap;
}
